import { Icon, Text } from '@fluentui/react';
import DialogTemplate from '../Common/DialogTemplate';
import { useTranslation, Trans } from 'react-i18next';

export interface RefreshPageDialogProps {
  show: boolean;
  onClose: (accept: boolean) => void;
}

export const RefreshPageDialog = (props: RefreshPageDialogProps) => {
  const { t } = useTranslation();

  const cancel = () => {
    props.onClose(false);
  };

  const accept = () => {
    props.onClose(true);
  };

  return (
      <DialogTemplate
          showDialog={props.show}
          toggleShowDialog={() => props.onClose(false)}
          title={t("Debes refrescar la aplicación")}
          onAccept={accept}
          onCancel={cancel}
          acceptText={t("Refrescar")}
          cancelText={t("Cancelar")}
          minWidth={600}
      >
        <div>
          <Trans>
            <Text block variant="medium">
              <Icon iconName="Warning" className="text-icon" />
              {t("Para que toda la aplicación tome los cambios del idioma debes refrescar. Quieres refrescar ahora?")}
            </Text>
          </Trans>
        </div>
      </DialogTemplate>
  );
};
